// import { apiSlice } from "../../app/api/apiSlice";

import { apiSlice } from "../../api/apiSlice";

export const FeatureArticleApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getFeatureArticle: builder.query({
      query: ({ limit, page, search }) =>
        `/api/v1/admin/feature-article/listing?page=${page}&limit=${limit}&search=${encodeURIComponent(
          search
        )}`,
      providesTags: (result, error) => [{ type: "FeatureArticle" }],
    }),
    
    createFeatureArticle: builder.mutation({
      query: (data) => {
        return {
          url: "/api/v1/admin/feature-article",
          method: "POST",
          body: data,
          // headers: {
          //   "Content-Type": "multipart/form-data",
          // },
        };
      },
      invalidatesTags: ["FeatureArticle"],
    }),

    getFeatureArticleById: builder.query({
      query: (id) => `/api/v1/admin/feature-article/${id}`,
      providesTags: (result, error, id) => [{ type: "FeatureArticle", id }],
    }),

    updateFeatureArticle: builder.mutation({
      query: ({ id, data }) => {
        return {
          url: `/api/v1/admin/feature-article/${id}`,
          method: "PATCH",
          body: data,
        };
      },
      invalidatesTags: ["FeatureArticle"],
    }),

    deleteFeatureArticle: builder.mutation({
      query: (id) => ({
        url: `/api/v1/admin/feature-article/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["FeatureArticle"],
    }),
  }),
});

export const {
  useGetFeatureArticleQuery,
  useCreateFeatureArticleMutation,
  useUpdateFeatureArticleMutation,
  useGetFeatureArticleByIdQuery,
  useDeleteFeatureArticleMutation,
} = FeatureArticleApiSlice;
